__turbopack_context__.v({
  "root": "FaqBulletList-module-scss-module__zUDI-G__root",
});
